export const formConfig = {
    CREATE_CLIENT: {
        fields: {
            clientId: {
                validators: ['required'],
            },
            clientSecret: {
                validators: ['required'],
            },
            redirectUris: {
                validators: ['required'],
            },
        },
    },
    UPDATE_CLIENT: {
        fields: {
            clientId: {
                validators: ['required'],
            },
            redirectUris: {
                validators: ['required'],
            },
        },
    },
    CREATE_ROLE: {
        fields: {
            name: {
                validators: ['required'],
            },
            clientId: {
                validators: ['required'],
            },
            admin: {
                default: false,
            },
        },
    },
    UPDATE_ROLE: {
        fields: {
            name: {
                validators: ['required'],
            },
            clientId: {
                validators: ['required'],
            },
        },
    },
    CREATE_USER: {
        fields: {
            username: {
                validators: ['username'],
            },
            name: {
                validators: ['required'],
            },
            email: {
                validators: ['required', 'email'],
            },
            roleIds: {
                validators: ['required'],
            },
            active: {
                default: true,
            },
        },
    },
    UPDATE_USER: {
        fields: {
            username: {
                validators: ['username'],
            },
            name: {
                validators: ['required'],
            },
            email: {
                validators: ['required', 'email'],
            },
            roleIds: {
                validators: ['required'],
            },
        },
    },
};
